import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import { colors } from "../../../theme/theme";

const SIZE_HEIGHTS = {
  xs: "300px",
  sm: "40px",
  md: "50px",
  lg: "60px",
};

const BaseBtn = styled(Button)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textTransform: "none",
  borderRadius: "10px",
  boxShadow: "none",
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: 500,
  letterSpacing: 0,
  fontSize: "18px",
  paddingLeft: "50px",
  paddingRight: "50px",
  whiteSpace: "normal",
  overflowWrap: "break-word",
  minHeight: "50px",
  [theme.breakpoints.down("md")]: {
    minHeight: "40px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    paddingLeft: "20px",
    paddingRight: "20px",
    minHeight: "30px",
  },
}));

export const StyledCustomBtn = styled(BaseBtn, {
  shouldForwardProp: (prop) =>
    !["$noMt", "$noMb", "$btnWidth", "$size", "$disabled"].includes(prop),
})(({ theme, $noMt, $noMb, $btnWidth, $size, $disabled }) => {
  const height = SIZE_HEIGHTS[$size] || SIZE_HEIGHTS.md;
  const width = $btnWidth || ($size === "sm" ? "auto" : "45%");
  const bgColor = $disabled ? "#ccc" : colors.secondary;
  const hoverBg = $disabled ? "#ccc" : "#1f2e3e";

  return {
    marginTop: $noMt ? 0 : 16,
    marginBottom: $noMb ? 0 : 16,
    width,
    minHeight: height,
    height: "auto",
    backgroundColor: bgColor,
    color: colors.white,
    "&:hover": {
      backgroundColor: hoverBg,
      boxShadow: "none",
    },
  };
});

export const StyledSecondaryBtn = styled(BaseBtn, {
  shouldForwardProp: (prop) => !["$noMt", "$noMb", "$btnWidth"].includes(prop),
})(({ $noMt, $noMb, $btnWidth }) => ({
  marginTop: $noMt ? 0 : 16,
  marginBottom: $noMb ? 0 : 16,
  width: $btnWidth || "45%",
  height: "auto",
  backgroundColor: "transparent",
  border: `1px solid ${colors.secondary}`,
  color: colors.secondary,
  "&:hover": {
    borderColor: colors.secondary,
    backgroundColor: "rgba(41, 64, 90, 0.04)",
    boxShadow: "none",
  },
}));

// export const iconSx = { marginLeft: 1 };
